<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-item>
        <ion-label position="stacked">Type to search media</ion-label>
        <ion-input
          [(ngModel)]="searchText"
          (keyup)="GetMediaSelectionList()"
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Click on a Media item to select</ion-label>
      </ion-item>

      <!-- <ion-tabs> -->
      <ion-tab-bar slot="bottom">
        <ion-tab-button
          [ngStyle]="{'text-decoration': mediaTypeSelected == 'Pictures'? 'underline' : 'none'}"
          tab="Pictures"
          (click)="setMediaTypeSelected('Pictures')"
        >
          <ion-icon name="images"></ion-icon>
          <ion-label>Pictures</ion-label>
          <ion-badge>6</ion-badge>
        </ion-tab-button>

        <ion-tab-button
          [ngStyle]="{'text-decoration': mediaTypeSelected == 'Videos'? 'underline' : 'none'}"
          tab="Video"
          (click)="setMediaTypeSelected('Videos')"
        >
          <ion-icon name="videocam"></ion-icon>
          <ion-label>Video</ion-label>
        </ion-tab-button>

        <ion-tab-button
          [ngStyle]="{'text-decoration': mediaTypeSelected == 'Documents'? 'underline' : 'none'}"
          tab="Documents"
          (click)="setMediaTypeSelected('Documents')"
        >
          <ion-icon name="document"></ion-icon>
          <ion-label>Documents</ion-label>
        </ion-tab-button>

        <ion-tab-button
          [ngStyle]="{'text-decoration': mediaTypeSelected == 'HTML'? 'underline' : 'none'}"
          tab="HTML and Unity"
          (click)="setMediaTypeSelected('HTML')"
        >
          <ion-icon name="logo-html5"></ion-icon>
          <ion-label>HTML and Unity</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
      <!-- </ion-tabs> -->

      <ion-grid>
        <ion-row>
          <div *ngFor="let mediaSelection of mediaSelectionList;">
            <ion-col
              class="grid-block"
              (click)="onMediaSelectionSelect($event,mediaSelection)"
            >
              <div
                *ngIf="mediaSelection?.VendorMediaSelectionPictureContent_GUID != ''"
              >
                <img
                  class="media-thumbnail-img"
                  style="padding: 20px; padding-bottom: 5px"
                  (error)="globals.onThumbnailError($event,'blank.jpg')"
                  src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + mediaSelection?.Content_GUID + '.jpg'}}"
                />
              </div>

              <div
                style="
                  padding: 20px;
                  padding-top: 0px;
                  padding-bottom: 5px;
                  width: 200px;
                "
              >
                <ion-label style="font-weight: bold; width: 30px"
                  >{{mediaSelection.text}}</ion-label
                ><br />
                <ion-label style="font-weight: bold; width: 30px"
                  >{{mediaSelection.Location}}</ion-label
                ><br />
              </div>
            </ion-col>
          </div>
        </ion-row>
      </ion-grid>

      <ion-infinite-scroll
        threshold="100px"
        (ionInfinite)="loadMoreData($event)"
      >
        <ion-infinite-scroll-content
          loadingSpinner="bubbles"
          loadingText="Loading more data..."
        >
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>

      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Close</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
